<template>
  <div class="body">
    <div class="title">
      会员资料审核
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>社团管理</el-breadcrumb-item>
          <el-breadcrumb-item>会员资料审核</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        <button size="medium" class="btn" @click="openccsss">
          <i class="el-icon-check"></i>
          批量通过</button>
      </div>
      <div class="csass"></div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-date-picker
              type="date"
              v-model="query.create_date"
              @change="Discountsearch"
              placeholder="申请日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-cascader :props="checkedData.typeOptions" @change="changList" clearable></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="审核状态" v-model="query.verify_status" @change="Discountsearch" style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="1" label="未审核 "></el-option>
              <el-option  name="selected" :value="2" label="已审核 "></el-option>
              <el-option  name="selected" :value="3" label="拒绝 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select  placeholder="会员状态" v-model="query.is_status" @change="Discountsearch"  style="min-width: 168px;width: 168px" clearable>
              <el-option  name="selected" :value="0" label="全部 "></el-option>
              <el-option  name="selected" :value="1" label="下架 "></el-option>
              <el-option  name="selected" :value="2" label="上架 "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="排序/跳转链接/链接说明 " v-model="query.keyword"  @change="Discountsearch" style="min-width: 168px;width: 336px;">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <el-table
      :stripe="true"
      :data="tableData"
      max-height="750"
      class="mytable-scrollbar"
      ref="EditUsertable"
      align="center"
      @selection-change="EdithandleSelectionChange"
      :row-key="(row) => row.user_id">
      <el-table-column
        type="selection"
        :reserve-selection="true"
      >
      </el-table-column>
      <el-table-column
        label="头像"
      >
        <template  slot-scope="scope">
          <img :src="scope.row.user_facepic"  min-width="70" height="70" :onerror="defaultImg"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="realname"
        label="姓名"
      >
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
      >
      </el-table-column>
      <el-table-column
        prop="com_identity"
        label="身份"
      >
      </el-table-column>
      <el-table-column
        label="所属地区"
      >
        <template  slot-scope="scope">
          {{scope.row.com_cityname}}{{scope.row.com_areaname}}
        </template>
      </el-table-column>
      <el-table-column
        prop="com_name"
        label="企业名称"
      >
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="提交时间"
      >
      </el-table-column>
      <el-table-column label="操作"  fixed="right" width="400">
        <template slot-scope="scope">
          <div class="row">
            <button  @click="Pushxiangqing(scope.row)" icon="el-icon-edit" class="sdbutton" >查看详情</button>
            <button  @click="tongguoshenqing(scope.row)" icon="el-icon-delete" class="tongguo" v-if="scope.row.verify_status ===0">通过申请</button>
            <button  @click="Pushjujue(scope.row)" icon="el-icon-delete" class="jujue"  v-if="scope.row.verify_status ===0">拒绝申请</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[10,15,20]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <vxe-modal width="336" ref="piliangtongguo" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="plClose">
        <div class="titledd">
          是否批量通过{{ NewArr.length }}个申请?
        </div>
        <div class="bobox">
          <button class="queren" @click="plqueren">
            确认
          </button>
          <button class="quxiao"  @click="plClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal v-model="tongguoshow" width="336" ref="tongguo" height="182" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClose">
        <div class="titledd">
          是否确认通过申请?
        </div>
        <div class="bobox">
          <button class="queren" @click="openqueren">
            确认
          </button>
          <button class="quxiao"  @click="routeClose">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
    <vxe-modal  width="336" ref="jujue" height="202" size="small" :show-footer="false" :showHeader="false" :show-close="true">
      <div class="popchuangkou">
        <img src="../../assets/img/closeaaaa.png" alt="" class="dsff" @click="routeClosecc">
        <div class="titledd mbP">
          是否拒绝通过申请?
        </div>
        <vxe-input v-model="remark" placeholder="请输入拒绝理由"></vxe-input>
        <div class="bobox">
          <button class="queren" @click="openjujue">
            确认
          </button>
          <button class="quxiao"  @click="routeClosecc">
            取消
          </button>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { cardlist, cardSetverifystatus } from '@/api/tongxunlu'
import { area, city, province, provinceCity } from '@/api/city'

export default {
  name: 'index',
  data () {
    return {
      checkedData: {
        // sendData: ['province_name'], // 默认选中值
        typeOptions: {
          lazy: true, // 开启懒加载
          lazyLoad: this.lazyLoad
        }
      },
      tongguoshow: false,
      value: '',
      tableData: [],
      itemcc: {},
      pageshow: true,
      query: {
        token: sessionStorage.getItem('token'),
        create_date: '',
        verify_status: 0,
        com_provinceid: 0,
        com_cityid: 0,
        com_areaid: 0,
        is_status: 0,
        keyword: '',
        page: 1,
        pagesize: 10
      },
      optiontype: [
        {
          value: '1',
          label: '商会 '
        }, {
          value: '2',
          label: '协会'
        }],
      total: null,
      cur_page: 1,
      CityInfo: [],
      remark: '',
      orach: null,
      NewArr: []
    }
  },
  created () {
    this.xiehuiList()
    this.city()
  },
  computed: {
    defaultImg () {
      return 'this.src="' + require('../../assets/img/no.jpg') + '";'
    }
  },
  methods: {
    changList (val) {
      this.query.org_provinceid = val[0]
      this.query.org_cityid = val[1]
      this.query.org_areaid = val[2]
      this.Discountsearch()
    },
    async lazyLoad (node, resolve) {
      const level = node.level
      let result
      let res
      let param
      switch (level) {
        case 0: // 一级
          res = await province()
          result = res.data.list
          result.forEach((item) => {
            item.value = item.province_id
            item.label = item.province_name
          })
          break
        case 1: // 二级
          console.log(node.data.province_id)
          param = {
            province_id: node.data.province_id
          }
          res = await city(
            param
          )
          result = res.data.list
          // console.log(result)
          result.forEach((item) => {
            item.value = item.city_id
            item.label = item.city_name
          })
          break
        case 2: // 三级目录
          console.log(node.data.city_id)
          param = {
            city_id: node.data.city_id
          }
          res = await area(
            param
          )
          result = res.data.list
          result.forEach((item) => {
            item.value = item.area_id
            item.label = item.area_name
            item.leaf = level >= 2
          })
          break
        // case 3: // 三级目录
        //   param = {
        //     area_id: node.data.area_id
        //   }
        // res = await getStreet(
        //   param
        // )
        // result = res.list
        // result.forEach((item) => {
        //   item.value = item.street_id
        //   item.label = item.short_name
        //   // 大于三级后不再显示后面的，到此结束
        //   item.leaf = level >= 3
        // })
        // break
        default:
          result = []
          break
      }
      console.log(result)
      resolve(result)
    },
    Pushxiangqing (item) {
      this.$store.commit('sethuiyuanID', item.id)
      this.$router.push('/huiyuanxiangqingchakan')
    },
    openccsss () {
      this.$refs.piliangtongguo.open()
    },
    plClose () {
      this.$refs.piliangtongguo.close()
    },
    plqueren () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.orach,
        apply_type: 1,
        apply_remark: this.apply_remark
      }
      cardSetverifystatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.piliangtongguo.close()
          this.xiehuiList()
        }
      })
    },
    EdithandleSelectionChange (val) {
      console.log('val', val)
      const Arr = []
      val.forEach(i => {
        Arr.push(i.id)
        this.NewArr = [...new Set(Arr)]
        console.log('NewArr', this.NewArr)
        console.log(JSON.stringify(this.NewArr).replace(/\[|]/g, ''))
        this.orach = JSON.stringify(this.NewArr).replace(/\[|]/g, '')
      })
    },
    routeClosecc () {
      this.$refs.jujue.close()
    },
    Pushjujue (item) {
      this.$refs.jujue.open()
      this.itemcc = item
    },
    routeClose () {
      this.$refs.tongguo.close()
      this.xiehuiList()
    },
    openjujue () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.itemcc.id,
        apply_type: 2,
        apply_remark: this.remark
      }
      cardSetverifystatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.jujue.close()
          this.xiehuiList()
        }
      })
    },
    openqueren () {
      const obj = {
        token: sessionStorage.getItem('token'),
        ids: this.itemcc.id,
        apply_type: 1
      }
      cardSetverifystatus(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === -1) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          setTimeout(() => {
            window.sessionStorage.clear()
            this.$router.push('/login')
          }, 1000)
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
          this.$refs.tongguo.close()
          this.xiehuiList()
        }
      })
    },
    tongguoshenqing (item) {
      console.log('item', item)
      this.tongguoshow = true
      this.itemcc = item
    },
    city () {
      provinceCity().then(({ data: res }) => {
        this.CityInfo = res.list
        console.log('city', res)
        const arr = JSON.parse(
          JSON.stringify(this.CityInfo)
            .replace(/province_name/g, 'label')
            .replace(/province_id/g, 'value')
        )
        this.CityInfo = arr
      })
    },
    Discountsearch () {
      this.cur_page = 1
      this.xiehuiList()
      this.pageshow = false// 让分页隐藏
      this.$nextTick(() => { // 重新渲染分页
        this.pageshow = true
      })
    },
    handleSizeChange (val) {
      this.query.pagesize = val
      this.handleCurrentChange(this.query.page)
    },
    handleCurrentChange (val) {
      this.query.page = val
      cardlist(this.query).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
      })
    },
    xiehuiList () {
      cardlist(this.query).then(({ data: res }) => {
        console.log('res', res)
        this.tableData = res.list
        this.total = res.total
      })
    }
  }
}
</script>

<style lang="less">
.el-table th:nth-child(9 )>.cell {
  display: inline-block;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  padding-left: 10px;
  padding-right: 10px;
  width: 100%;
  text-align: center;
}
.el-scrollbar__wrap{
  height: 200px ;
}
.popchuangkou{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  .mbP{
    margin-bottom: 24px;
  }
  .dsff{
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
  }
  .titledd{
    margin-top: 22px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 500;
    text-align: left;
    color: #2e2e2e;
  }
  .einput{
    width: 253px;
    height: 44px;
    opacity: 1;
    background: #fbfbfb;
    border-radius: 5px;
  }
  .bobox{
    margin-top: 43px;
    display:flex;
    flex-direction: row;
    align-items: center;
  }
  .queren{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    margin-right: 12px;
  }
  .quxiao{
    width: 95px;
    height: 36px;
    opacity: 1;
    background: rgba(61,154,255,0.10);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
  }
}
.tongguo{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #0fa838;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  margin-right: 12px;
}
.jujue{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #e54848;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  margin-right: 12px;
}
.rou{
  display:flex;
  flex-direction: row;
  align-items: center;
}
.sdbutton{
  width: 78px;
  height: 37px;
  opacity: 1;
  border: 1px solid rgba(61,154,255,0.50);
  border-radius: 2px;
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #3d9aff;
  letter-spacing: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  margin-right: 12px;
}
.weitongguo{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #e54848;
  letter-spacing: 0px;
}
.daitongguo{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #f7d05c;
  letter-spacing: 0px;
}
.weizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.yizhiding{
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  color: #0fa838;
  letter-spacing: 0px;
}
.imgs{
  width: 45px;
  height: 45px;
  opacity: 1;
  background: rgba(0,0,0,0.00);
  border-radius: 50%;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display:flex;
    flex-direction: row;
    align-items: center;
    .fansk{
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf{
      color: #3D9AFF;
    }
  }
  .btnsearch{
    display:flex;
    flex-direction: row;
    align-items: center;
    .left{
      margin-right: 150px;
      .btn{
        width: 124px;
        height: 43px;
        opacity: 1;
        background: linear-gradient(135deg,#1bb745, #17ab3f);
        border-radius: 5px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        letter-spacing: 0px;
        border: none;
      }
    }
    .right{
      margin-top: 27px;
    }
  }
}
</style>
